const headers = {
  name: "Contractor",
  navigate: {
    path: [
      {
        name: "Contractors",
        path: "/app/contractors",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
